// Utility function to convert IQnANode to ISafeNode
export function getSafeData(node) {
    return {
        id: node._id,
        type: node.type,
        data: node.data,
        attributes: node.attributes,
        sequence: node.sequence,
        config: node.config,
        ancestors: node.ancestors,
        author: node.author,
        updatedBy: node.updatedBy,
        deleted: node.deleted,
        ctime: node.ctime,
        utime: node.utime,
    };
}
